import React, { useEffect, useState } from 'react';
import agentApiService from '../../services/agentApiService';

const ApiServiceTest = () => {
  const [testResults, setTestResults] = useState([]);

  useEffect(() => {
    const runTests = () => {
      const results = [];

      // Test 1: Check if service exists
      results.push({
        test: 'Service Import',
        result: agentApiService ? 'PASS' : 'FAIL',
        details: `Type: ${typeof agentApiService}`
      });

      // Test 2: Check if getCustomerDetail method exists
      results.push({
        test: 'getCustomerDetail Method',
        result: typeof agentApiService.getCustomerDetail === 'function' ? 'PASS' : 'FAIL',
        details: `Type: ${typeof agentApiService.getCustomerDetail}`
      });

      // Test 3: Check if submitCustomerDetails method exists
      results.push({
        test: 'submitCustomerDetails Method',
        result: typeof agentApiService.submitCustomerDetails === 'function' ? 'PASS' : 'FAIL',
        details: `Type: ${typeof agentApiService.submitCustomerDetails}`
      });

      // Test 4: Check if getAllPassengerDetails method exists
      results.push({
        test: 'getAllPassengerDetails Method',
        result: typeof agentApiService.getAllPassengerDetails === 'function' ? 'PASS' : 'FAIL',
        details: `Type: ${typeof agentApiService.getAllPassengerDetails}`
      });

      // Test 5: Check if confirmBooking method exists
      results.push({
        test: 'confirmBooking Method',
        result: typeof agentApiService.confirmBooking === 'function' ? 'PASS' : 'FAIL',
        details: `Type: ${typeof agentApiService.confirmBooking}`
      });

      // Test 6: List all available methods
      const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(agentApiService))
        .filter(name => name !== 'constructor' && typeof agentApiService[name] === 'function');
      
      results.push({
        test: 'Available Methods',
        result: methods.length > 0 ? 'PASS' : 'FAIL',
        details: `Methods: ${methods.join(', ')}`
      });

      setTestResults(results);
    };

    runTests();
  }, []);

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">API Service Test Results</h1>
      
      <div className="space-y-4">
        {testResults.map((result, index) => (
          <div 
            key={index}
            className={`p-4 rounded-lg border ${
              result.result === 'PASS' 
                ? 'bg-green-50 border-green-200' 
                : 'bg-red-50 border-red-200'
            }`}
          >
            <div className="flex items-center justify-between">
              <h3 className="font-semibold">{result.test}</h3>
              <span className={`px-2 py-1 rounded text-sm font-medium ${
                result.result === 'PASS'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-red-100 text-red-800'
              }`}>
                {result.result}
              </span>
            </div>
            <p className="text-sm text-gray-600 mt-2">{result.details}</p>
          </div>
        ))}
      </div>

      <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <h3 className="font-semibold text-blue-900 mb-2">Service Instance Info</h3>
        <pre className="text-sm text-blue-800 overflow-x-auto">
          {JSON.stringify({
            constructor: agentApiService.constructor.name,
            baseUrl: agentApiService.baseUrl,
            instanceProperties: Object.getOwnPropertyNames(agentApiService),
            prototypeProperties: Object.getOwnPropertyNames(Object.getPrototypeOf(agentApiService))
          }, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default ApiServiceTest;